module.exports = __webpack_public_path__ + "img/vacinas_nao_enviadas.e39cb731.png";